/**
 * A força da senha, conferida ENQUANTO se digita — com a mesma régua do servidor.
 *
 * `auth.conferirForca` recusa na hora de gravar, e a recusa chegava como um
 * balão depois do clique: a pessoa inventava uma senha, apertava, lia "a senha
 * não pode conter o seu nome" e recomeçava. Aqui as mesmas regras respondem
 * letra a letra, e o botão só acende quando o servidor vai aceitar.
 *
 * O que decide é `problema` (a frase da recusa, ou nulo); `nivel` é só o
 * desenho da barra — uma senha aceita pode ser "boa" ou "forte", e dizer isso
 * incentiva a mais longa sem barrar a que já serve.
 *
 * `PROIBIDAS` é cópia da lista de `src/auth.ts`, e `senha.test.jsx` confere as
 * duas: se o servidor passar a barrar outra, a tela não pode acender o botão
 * para ela.
 */

export const MINIMO = 12;

export const PROIBIDAS = [
  "123456789012",
  "senha123456",
  "password1234",
  "qwertyuiop12",
  "advocacia123",
  "galera123456",
  "12345678",
  "password",
  "senhasenha",
];

const ROTULOS = ["Curta demais", "Fraca", "Aceita", "Boa", "Forte"];

/**
 * @param {string} senha
 * @param {{ nome?: string, email?: string }} dono
 * @returns {{ nivel: 0|1|2|3|4, rotulo: string, problema: string|null, falta: number }}
 */
export function forcaDaSenha(senha, dono = {}) {
  const s = String(senha ?? "").normalize("NFKC");
  const baixa = s.toLowerCase();
  const usuario = dono.email?.split("@")[0]?.toLowerCase();
  const primeiro = dono.nome?.trim().split(/\s+/)[0]?.toLowerCase();
  const falta = Math.max(0, MINIMO - s.length);

  let problema = null;
  if (falta) problema = `Faltam ${falta} caractere${falta > 1 ? "s" : ""} — o mínimo é ${MINIMO}.`;
  else if (s.length > 200) problema = "Senha longa demais.";
  else if (PROIBIDAS.some((p) => baixa.includes(p)) || /^(.)\1+$/.test(s)) problema = "Essa senha é fácil demais de adivinhar.";
  else if (usuario && usuario.length > 2 && baixa.includes(usuario)) problema = "A senha não pode conter o seu e-mail.";
  else if (primeiro && primeiro.length > 2 && baixa.includes(primeiro)) problema = "A senha não pode conter o seu nome.";

  if (problema) return { nivel: falta && s.length < 8 ? 0 : 1, rotulo: ROTULOS[falta && s.length < 8 ? 0 : 1], problema, falta };

  /* Aceita. Daqui em diante é só incentivo: comprimento e variedade. */
  const tipos = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^A-Za-z0-9]/].filter((r) => r.test(s)).length;
  const nivel = s.length >= 16 && tipos >= 3 ? 4 : s.length >= 14 || tipos >= 3 ? 3 : 2;
  return { nivel, rotulo: ROTULOS[nivel], problema: null, falta: 0 };
}
